import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-delimiter-dialog',
    templateUrl: './delimiter-dialog.component.html',
    styleUrls: ['./delimiter-dialog.component.css'],
    standalone: false
})
export class DelimiterDialogComponent {
  delimiter: string = ",";   // default

  constructor(private dialogRef: MatDialogRef<DelimiterDialogComponent>) {}

  confirm() {
    this.dialogRef.close(this.delimiter);
  }
}
